import React, { useState } from 'react';
import { FaPlay, FaExternalLinkAlt } from 'react-icons/fa';
import { SERVER } from '../config/config';

const VideoPlayer = ({ 
  video, 
  className = "", 
  showTitle = true, 
  autoPlay = false 
}) => {
  const [isPlaying, setIsPlaying] = useState(autoPlay);
  const [error, setError] = useState(false);

  if (!video || !video.video_file) {
    return null;
  }

  const handlePlay = () => {
    setIsPlaying(true);
  };

  const handleError = () => {
    setError(true);
  };

  if (error) {
    return (
      <div className={`bg-gray-100 rounded-lg p-8 text-center ${className}`}>
        <p className="text-gray-500 mb-4">Unable to load video</p>
        <p className="text-sm text-gray-400">{video.video_title}</p>
      </div>
    );
  }

  const videoUrl = `${SERVER}${video.video_file}`;

  return (
    <div className={`relative group ${className}`}>
      {/* Video Container */}
      <div className="relative w-full max-h-[500px] aspect-video bg-black rounded-3xl overflow-hidden">
        {!isPlaying ? (
          // Thumbnail with play button
          <div className="relative w-full h-full cursor-pointer" onClick={handlePlay}>
            {/* Video thumbnail - first frame */}
            <video
              src={videoUrl}
              className="w-full h-full object-cover"
              muted
              preload="metadata"
              onError={handleError}
            />
            
            {/* Play button overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center group-hover:bg-opacity-40 transition-all duration-300">
              <div className="w-16 h-16  flex items-center justify-center  transform group-hover:scale-110 transition-transform duration-300">
                <FaPlay className="text-white ml-1" size={50} />
              </div>
            </div>

            {/* Click to play text */}
            <div className="absolute bottom-4 left-4 text-white text-sm opacity-75">
              Click to play video
            </div>
          </div>
        ) : (
          // Video player
          <video
            src={videoUrl}
            controls
            autoPlay
            className="w-full h-full"
            onError={handleError}
          >
            Your browser does not support the video tag.
          </video>
        )}
      </div>

      {/* Video Info */}
      {showTitle && video.video_title && (
        <div className="mt-4">
          <h4 className="text-lg font-semibold text-gray-900">
            {video.video_title}
          </h4>
        </div>
      )}
    </div>
  );
};

export default VideoPlayer;